/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Translation_Import_Failed_ToastInputs */

const en_translation_import_failed_toast = /** @type {(inputs: Translation_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importing translation events failed: ${i?.error}`)
};

const fr_translation_import_failed_toast = /** @type {(inputs: Translation_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'importation des événements de traduction a échoué : ${i?.error}`)
};

const de_translation_import_failed_toast = /** @type {(inputs: Translation_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import der Übersetzungsereignisse fehlgeschlagen: ${i?.error}`)
};

const it_translation_import_failed_toast = /** @type {(inputs: Translation_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione degli eventi di traduzione non riuscita: ${i?.error}`)
};

const ru_translation_import_failed_toast = /** @type {(inputs: Translation_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать события перевода: ${i?.error}`)
};

const es_translation_import_failed_toast = /** @type {(inputs: Translation_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al importar los eventos de traducción: ${i?.error}`)
};

const zh_cn2_translation_import_failed_toast = /** @type {(inputs: Translation_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入翻译事件失败：${i?.error}`)
};

const ja_translation_import_failed_toast = /** @type {(inputs: Translation_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`翻訳イベントのインポートに失敗しました: ${i?.error}`)
};

const hi_translation_import_failed_toast = /** @type {(inputs: Translation_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अनुवाद संबंधी इवेंट आयात करने में विफलता: ${i?.error}`)
};

const pt_pt2_translation_import_failed_toast = /** @type {(inputs: Translation_Import_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A importação de eventos de tradução falhou: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Importing translation events failed: {error}" |
*
* @param {Translation_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_failed_toast = /** @type {((inputs: Translation_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_import_failed_toast(inputs)
	if (locale === "de") return de_translation_import_failed_toast(inputs)
	if (locale === "it") return it_translation_import_failed_toast(inputs)
	if (locale === "ru") return ru_translation_import_failed_toast(inputs)
	if (locale === "es") return es_translation_import_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_import_failed_toast(inputs)
	if (locale === "ja") return ja_translation_import_failed_toast(inputs)
	if (locale === "hi") return hi_translation_import_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_import_failed_toast(inputs)
	return en_translation_import_failed_toast(inputs)
});